/* eslint-disable no-undef */

document.addEventListener('DOMContentLoaded', () => {
  const script = document.createElement('script');
  script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
  script.async = true;
  script.onload = function () {
    loadAds(); // wordt gegarandeerd pas uitgevoerd na laden
  };
  document.head.appendChild(script);
});

window.googletag = window.googletag || { cmd: [] };

function loadAds() {
  const mainAd = 'icreate';

  const topArray = ['/single.php', '/single-koopadvies.php', '/single-reviews.php', '/home.php', '/archive.php', '/page.php', '/archive-hardware.php', '/single-hardware.php', '/archive-software.php', '/single-software.php', '/page-template-tips.php', '/archive-magazine.php'];
  const mid1Array = ['/single.php', '/single-koopadvies.php', '/single-reviews.php', '/archive.php', '/single-hardware.php', '/archive-software.php', '/single-software.php'];

  const {pageType} = window;
  const {postType} = window;
  const {currentTemplate} = window;
  const {adTargeting} = window;
  
  const { isHomePage } = window;

  function defineMid1() {
    if (document.getElementById('mid1')) {
      if (pageType === 'list') {
        return true;
      }
  
      if (mid1Array.includes(currentTemplate) && window.innerWidth >= 1200) {
        return true;
      }
  
      return false;
    }
    return false;
  }
  

  // Wait for googletag to be fully initialized
  googletag.cmd.push(() => {
    // Ensure googletag is properly initialized
    if (typeof googletag.sizeMapping !== 'function') {
      /* eslint-disable no-console */
      console.error('googletag.sizeMapping is not available');
      return;
    }

    const mappingBillboard = googletag.sizeMapping()
      .addSize([1200, 0], [[970, 250], [728, 90]])
      .addSize([0, 0], [])
      .build();

    const mappingRectangle = googletag.sizeMapping()
      .addSize([1200, 0], [[300, 600], [300, 250]])
      .addSize([728, 0], [[300, 250], [320, 100], [360, 640], 'fluid'])
      .addSize([320, 0], [[320, 240], [300, 250], [320, 100], [360, 640], 'fluid'])
      .build();

    const mappingRectangleMobile = googletag.sizeMapping()
      .addSize([1200, 0], [])
      .addSize([728, 0], [[320, 240], [300, 250], [320, 100], [360, 640], 'fluid'])
      .addSize([320, 0], [[320, 240], [300, 250], [320, 100], [360, 640], 'fluid'])
      .build();

    // Function to initialize ads after GPT is loaded
    if (isHomePage && topArray.includes(currentTemplate)) {
      // googletag.defineSlot(`/${window.dfpID}/${mainAd}/${window.postType}${isDetailPage}`, [[970, 250], [728, 90]], 'top')
      googletag.defineSlot(`/${window.dfpID}/${mainAd}/homepage/${postType}`, [[970, 250], [728, 90]], 'top')
        .setTargeting('pos', ['top'])
        .defineSizeMapping(mappingBillboard)
        .addService(googletag.pubads());
    }

    if (window.innerWidth >= 1200) {
      removeAdUnitsForMobile();
    } else {
      removeAdUnitsForDesktop();
    }

    if (!isHomePage && topArray.includes(currentTemplate)) {
        if (window.innerWidth >= 1200) {
          googletag.defineSlot(`/${window.dfpID}/${mainAd}/${postType}/${pageType}`, [[970, 250], [728, 90]], 'top')
            .setTargeting('pos', ['top'])
            .defineSizeMapping(mappingBillboard)
            .addService(googletag.pubads());
        }

        if (window.innerWidth < 1200 && document.getElementById('top_mobile')) {
          googletag.defineSlot(`/${window.dfpID}/${mainAd}/${postType}/${pageType}`, [[320, 240], [300, 250], [320, 100], [360, 640]], 'top_mobile')
            .setTargeting('pos', ['top'])
            .defineSizeMapping(mappingRectangleMobile)
            .addService(googletag.pubads());
        }
    }

    if (defineMid1()) {
      googletag.defineSlot(`/${window.dfpID}/${mainAd}/${postType}/${pageType}`, [[320, 240], [320, 100], [300, 250], [480, 640], [728, 90], [336, 280], [300, 600], 'fluid'], 'mid1')
        .setTargeting('pos', ['mid1'])
        .defineSizeMapping(mappingRectangle)
        .addService(googletag.pubads());
    }

    googletag.pubads().setTargeting('articleid', adTargeting?.articleid ?? []);
    googletag.pubads().setTargeting('categories', adTargeting?.categories ?? []);
    googletag.pubads().setTargeting('pagetype', adTargeting?.pagetype ?? []);
    googletag.pubads().setTargeting('model', adTargeting?.model ?? []);
    googletag.pubads().setTargeting('topic', adTargeting?.topic ?? []);

    googletag.pubads().collapseEmptyDivs();
    googletag.pubads().setCentering(true);
    googletag.pubads().enableLazyLoad({
      fetchMarginPercent: 25,
      renderMarginPercent: 0,
      mobileScaling: 1,
    });
    googletag.enableServices();

    if (topArray.includes(window.currentTemplate) && document.getElementById('top') && window.innerWidth >= 1200) {
      googletag.display('top');

    }
    
    if (document.getElementById('top_mobile') && window.innerWidth < 1200) {
      googletag.display('top_mobile');
    }

    if (defineMid1()) {
      googletag.display('mid1');
    }
  });

  /* eslint-enable no-undef */
}

function removeAdUnitsForMobile() {
  const adUnits = document.querySelectorAll('.js-mobile-ad');
  adUnits.forEach((adUnit) => {
    adUnit.remove();
  });
}

function removeAdUnitsForDesktop() {
  const adUnits = document.querySelectorAll('.js-desktop-ad');
  adUnits.forEach((adUnit) => {
    adUnit.remove();
  });
}


function fillAdUnits(number) {

  if (window.innerWidth >= 1200) {
    removeAdUnitsForMobile();
  } else {
    removeAdUnitsForDesktop();
  }
  
  if (!number) {
    return;
  }

  if (window.innerWidth < 1200) {
    number -= 1;
  }

  const slotId = `mid${number}`;
  const adElement = document.getElementById(slotId);
  
  if (!adElement) {
    console.warn(`Ad element with id "${slotId}" not found`);
    return;
  }

  // Check if slot is already defined to avoid redefining
  googletag.cmd.push(() => {
    // Check if slot already exists
    const existingSlot = googletag.pubads().getSlots().find(slot => slot.getSlotElementId() === slotId);
    if (existingSlot) {
      // Slot already exists, just refresh it
      googletag.pubads().refresh([existingSlot]);
      return;
    }

    // Define new slot
    const mappingRectangle = googletag.sizeMapping()
      .addSize([1200, 0], [[300, 600], [300, 250]])
      .addSize([728, 0], [[728, 90], [300, 250], [320, 240], [336, 280], 'fluid'])
      .addSize([320, 0], [[320, 240], [300, 250]])
      .build();

    const slot = googletag.defineSlot(`/${window.dfpID}/icreate/${window.postType}/${window.pageType}`, [[320, 240], [320, 100], [300, 250], [480, 640], [728, 90], [336, 280], [300, 600], 'fluid'], slotId)
      .setTargeting('pos', [slotId])
      .defineSizeMapping(mappingRectangle)
      .addService(googletag.pubads());

    // Enable services for the new slot
    googletag.enableServices();

    // Display the ad
    googletag.display(slotId);

    // Refresh the slot after a small delay to ensure the element is ready
    setTimeout(() => {
      googletag.cmd.push(() => {
        googletag.pubads().refresh([slot]);
      });
    }, 100);
  });
}
 